import { ServiceData } from '../../data/services';

const stripHtml = (html: string): string => html.replace(/<[^>]*>/g, '').replace(/\s+/g, ' ').trim();

export const ORGANIZATION_SCHEMA = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "@id": "https://ortemtech.com/#organization",
    "name": "Ortem Technologies",
    "legalName": "Ortem Technologies LLC",
    "description": "Ortem Technologies is a global custom software, AI, web & mobile app development company that has delivered 1,000+ projects for 300+ clients across USA, UK, Australia, Middle East, and APAC.",
    "foundingDate": "2012",
    "numberOfEmployees": {
        "@type": "QuantitativeValue",
        "value": 200
    },
    "url": "https://ortemtech.com",
    "logo": {
        "@type": "ImageObject",
        "url": "https://ortemtech.com/assets/ot-logo-mark.png",
        "width": 512,
        "height": 512
    },
    "image": "https://ortemtech.com/assets/ot-logo-mark.png",
    "telephone": "+1-519-502-1577",
    "email": "sales@ortemtech.com",
    "address": {
        "@type": "PostalAddress",
        "streetAddress": "16192 Coastal Highway",
        "addressLocality": "Lewes",
        "addressRegion": "DE",
        "postalCode": "19958",
        "addressCountry": "US"
    },
    // aggregateRating removed — canonical rating lives in schemaGenerator.ts Organization schema
    // Having multiple aggregateRating blocks for the same entity triggers GSC errors
    "sameAs": [
        "https://www.linkedin.com/company/ortem-technologies-llc/",
        "https://www.youtube.com/@ortemtechnologies",
        "https://clutch.co/profile/ortem-technologies/",
        "https://www.goodfirms.co/company/ortem-technologies-llc",
        "https://techbehemoths.com/company/ortem-technologies-llc",
        "https://www.g2.com/products/ortem-technologies-ortem-technologies/reviews",
        "https://www.truefirms.co/company/Ortem-Technologies-LLC/3773",
        "https://x.com/ortemtech",
        "https://www.instagram.com/ortemtech/",
        "https://tracxn.com/d/companies/ortem-technologies/",
        "https://www.crunchbase.com/organization/ortem-technologies",
        "https://www.upwork.com/agencies/ortemtech"
    ],
    "areaServed": { "@type": "Place", "name": "Worldwide" },
    "knowsAbout": [
        "Custom Software Development",
        "Mobile App Development",
        "AI Development",
        "Web Development",
        "Cloud Computing",
        "DevOps",
        "IoT Development",
        "eCommerce Development",
        "SaaS Development",
        "Staff Augmentation"
    ]
};

export const US_HQ_SCHEMA = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "@id": "https://ortemtech.com/#local-business",
    "name": "Ortem Technologies",
    "legalName": "Ortem Technologies LLC",
    "image": "https://ortemtech.com/assets/ot-logo-mark.png",
    "url": "https://ortemtech.com",
    "telephone": "+1-519-502-1577",
    "priceRange": "$$$",
    "parentOrganization": {
        "@id": "https://ortemtech.com/#organization"
    },
    "address": {
        "@type": "PostalAddress",
        "streetAddress": "16192 Coastal Highway",
        "addressLocality": "Lewes",
        "addressRegion": "DE",
        "postalCode": "19958",
        "addressCountry": "US"
    },
    "geo": {
        "@type": "GeoCoordinates",
        "latitude": 38.7746,
        "longitude": -75.1393
    },
    "openingHoursSpecification": {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": [
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday"
        ],
        "opens": "09:00",
        "closes": "18:00"
    },
    "areaServed": { "@type": "Place", "name": "Worldwide" },
    "sameAs": ORGANIZATION_SCHEMA.sameAs
};

export const generateServiceSchema = (service: ServiceData) => {
    const serviceUrl = `https://ortemtech.com/services/${service.slug}/`;
    return {
        "@context": "https://schema.org",
        "@type": "Service",
        "@id": `${serviceUrl}#service`,
        "serviceType": service.title,
        "provider": {
            "@type": "Organization",
            "name": "Ortem Technologies LLC",
            "url": "https://ortemtech.com"
        },
        "areaServed": { "@type": "Place", "name": "Worldwide" },
        "name": service.title,
        "description": service.metaDescription || service.heroDescription,
        "mainEntityOfPage": {
            "@type": "WebPage",
            "@id": `https://ortemtech.com/services/${service.slug}/`
        }
    };
};

export const generateFAQSchema = (faqs: { question: string; answer: string }[]) => {
    return {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        "mainEntity": faqs.map(faq => ({
            "@type": "Question",
            "name": faq.question,
            "acceptedAnswer": {
                "@type": "Answer",
                "text": stripHtml(faq.answer)
            }
        }))
    };
};

